import { TythonColumnsEnum } from '../../@data/store/schema/ColumnsEnum';
import { ChartGrain, ChartTypes, IChartButton, ReportCardType } from '../../DashboardCards/ReportCard/ReportCard.types';

export const ALLOWED_CHARTS: Partial<Record<ReportCardType, IChartButton[]>> = {
  [ReportCardType.ACCOUNT]: [{ chartType: ChartTypes.LINE, disabled: false, iconName: 'LineChart' }],
  [ReportCardType.distributionV2]: [{ chartType: ChartTypes.LINE, disabled: false, iconName: 'LineChart' }],
  [ReportCardType.SITE]: [
    { chartType: ChartTypes.BAR, disabled: false, iconName: 'BarChartHorizontal' },
    { chartType: ChartTypes.DONUT, disabled: false, iconName: 'DonutChart' },
    { chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' },
  ],
  [ReportCardType.ADUNIT]: [
    { chartType: ChartTypes.BAR, disabled: false, iconName: 'BarChartHorizontal' },
    { chartType: ChartTypes.DONUT, disabled: false, iconName: 'DonutChart' },
    { chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' },
  ],
  [ReportCardType.TYPE_TAG]: [
    { chartType: ChartTypes.BAR, disabled: false, iconName: 'BarChartHorizontal' },
    { chartType: ChartTypes.DONUT, disabled: false, iconName: 'DonutChart' },
    { chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' },
  ],
  [ReportCardType.DistributionPartnerTagV2]: [
    { chartType: ChartTypes.BAR, disabled: false, iconName: 'BarChartHorizontal' },
    { chartType: ChartTypes.DONUT, disabled: false, iconName: 'DonutChart' },
    { chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' },
  ],
  [ReportCardType.DistributionPTQS]: [{ chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' }],
  [ReportCardType.DistributionPTQSSnapshot]: [{ chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' }],
  [ReportCardType.PTQs]: [{ chartType: ChartTypes.GRID, disabled: false, iconName: 'GridViewSmall' }],
};

export const DEFAULT_METRICS: Partial<Record<ReportCardType, TythonColumnsEnum[]>> = {
  [ReportCardType.ACCOUNT]: [
    TythonColumnsEnum.EstimatedRevenue,
    TythonColumnsEnum.EstimatedRevenueInUSD,
    TythonColumnsEnum.BiddedSRPVs,
    TythonColumnsEnum.AdCTR,
    TythonColumnsEnum.NonBillableSRPVs,
    TythonColumnsEnum.RawSRPVs,
    TythonColumnsEnum.CPC,
    TythonColumnsEnum.Clicks,
  ],
  [ReportCardType.SITE]: [TythonColumnsEnum.EstimatedRevenue, TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks],
  [ReportCardType.ADUNIT]: [TythonColumnsEnum.EstimatedRevenue, TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks],
  [ReportCardType.TYPE_TAG]: [TythonColumnsEnum.EstimatedRevenue, TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks],
  [ReportCardType.PTQs]: [TythonColumnsEnum.EstimatedRevenue, TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks],
  [ReportCardType.distributionV2]: [
    TythonColumnsEnum.AdCTR,
    TythonColumnsEnum.AdDensity,
    TythonColumnsEnum.BiddedSRPVs,
    TythonColumnsEnum.Clicks,
    TythonColumnsEnum.CPC,
    TythonColumnsEnum.BiddedCTR,
    TythonColumnsEnum.SRPV,
    TythonColumnsEnum.Revenue,
  ],
  [ReportCardType.DistributionPartnerTagV2]: [TythonColumnsEnum.ARPV, TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks],
  [ReportCardType.DistributionPTQS]: [TythonColumnsEnum.ImpactScore],
  [ReportCardType.DistributionPTQSSnapshot]: [TythonColumnsEnum.NumberOfWeeks],
};

export const DEFAULT_ACTIVE_METRICS: Partial<Record<ReportCardType, TythonColumnsEnum[]>> = {
  [ReportCardType.ACCOUNT]: [
    TythonColumnsEnum.RawSRPVs,
    TythonColumnsEnum.BiddedSRPVs,
    TythonColumnsEnum.Clicks,
    TythonColumnsEnum.EstimatedRevenue,
  ],
  [ReportCardType.distributionV2]: [TythonColumnsEnum.BiddedSRPVs, TythonColumnsEnum.Clicks, TythonColumnsEnum.Revenue],
};

export const DEFAULT_COLUMN: Partial<Record<ReportCardType, TythonColumnsEnum>> = {
  [ReportCardType.SITE]: TythonColumnsEnum.SiteName,
  [ReportCardType.ADUNIT]: TythonColumnsEnum.AdUnitName,
  [ReportCardType.TYPE_TAG]: TythonColumnsEnum.TypeTag,
  [ReportCardType.PTQs]: TythonColumnsEnum.AdUnitName,
  [ReportCardType.DistributionPartnerTagV2]: TythonColumnsEnum.PartnerTag,
  [ReportCardType.DistributionPTQS]: TythonColumnsEnum.PartnerCode,
  [ReportCardType.DistributionPTQSSnapshot]: TythonColumnsEnum.PartnerCode,
};

export const DEFAULT_GRANULARITY: Partial<Record<ReportCardType, ChartGrain>> = {
  [ReportCardType.ACCOUNT]: ChartGrain.DAILY,
  [ReportCardType.SITE]: ChartGrain.NONE,
  [ReportCardType.ADUNIT]: ChartGrain.NONE,
  [ReportCardType.TYPE_TAG]: ChartGrain.NONE,
  [ReportCardType.PTQs]: ChartGrain.NONE,
  [ReportCardType.distributionV2]: ChartGrain.DAILY,
  [ReportCardType.DistributionPartnerTagV2]: ChartGrain.NONE,
  [ReportCardType.DistributionPTQS]: ChartGrain.NONE,
  [ReportCardType.DistributionPTQSSnapshot]: ChartGrain.NONE,
};

export const DEFAULT_SHOW_FLAG: Partial<Record<ReportCardType, 'Syndication' | 'Distribution' | 'DistributionV2'>> = {
  [ReportCardType.ACCOUNT]: 'Syndication',
  [ReportCardType.SITE]: 'Syndication',
  [ReportCardType.ADUNIT]: 'Syndication',
  [ReportCardType.TYPE_TAG]: 'Syndication',
  [ReportCardType.PTQs]: 'Syndication',
  [ReportCardType.distributionV2]: 'DistributionV2',
  [ReportCardType.DistributionPartnerTagV2]: 'DistributionV2',
  [ReportCardType.DistributionPTQS]: 'DistributionV2',
  [ReportCardType.DistributionPTQSSnapshot]: 'DistributionV2',
};
